<div class="cart-totals-floating">
  <div class="container-v2 totals-floating">
    <sd-cart-totals-order [cart]="cart()"></sd-cart-totals-order>
  </div>
</div>
